import "./Footer.css";
import { FaFacebookF, FaTwitter, FaLinkedinIn, FaInstagram } from "react-icons/fa";

export default function Footer() {
  return (
    <footer className="footer">

      <div className="footer-container">

        {/* LEFT - CAUTION */}
        <div className="footer-col">
          <h3>Caution</h3>
          <p>
            Sell Gold does not support stolen and illegal gold. Selling stolen
            gold or fake gold is considered to be a criminal offense.
            Anyone age 21 or less can sell gold only with a parent/guardian’s
            written letter.
          </p>
        </div>

        {/* CENTER - LINKS */}
        <div className="footer-col">
          <h3>Quick Links</h3>
          <ul>
            <li><a href="/">Home</a></li>
            <li><a href="/about">About</a></li>
            <li><a href="/services">Services</a></li>
            <li><a href="/contact">Contact</a></li>
            <li><a href="/privacy">Privacy Policy</a></li>
          </ul>
        </div>

        {/* RIGHT - CONTACT */}
        <div className="footer-col">
          <h3>Contact Info</h3>
          <p>
            No.1, opp. Bangalore Development Authority Complex,
            6th Block, 2nd Stage, Nagarabhavi, Bengaluru,
            Karnataka 560072
          </p>
          <p>+91 9143167167</p>
          <p>sellgoldcompany@gmail.com</p>
        </div>

      </div>

      {/* BOTTOM */}
      <div className="footer-bottom">
        <p>© 2026 - Sell Gold | All rights reserved.</p>

        <div className="social-icons">
          <FaFacebookF />
          <FaTwitter />
          <FaLinkedinIn />
          <FaInstagram />
        </div>
      </div>

    </footer>
  );
}